export const toOption = (value: string | number, label?: string) => ({ value, label: label || value.toString() });
